import React,{memo} from 'react';
//import React, { useState } from 'react';
import HighchartsReact from "highcharts-react-official";
import CountUp from "react-countup";
import { Fragment } from "react";
import Loader from "react-js-loader";
import ShimmerLoader from "../ShimmerLoader";

const CancerSites = memo((props) => {
  const {CancerSitesLoader,totalValue,primarySite,Fullscreen,cancerSiteTop10Data,Highcharts,topcansites,
     top10totalCount,cancerSiteRestOfData,resofcansites,totalCount, handleModalOpen,handleModalClose,} = props;

  return (
    <Fragment>
        {CancerSitesLoader === true && (
       <div
      style={{
      position: "fixed",
      top: 0,
      left: 70,
      width: "100vw",
      height: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
       zIndex: 9999
    }}
     >
    <Loader
      type="spinner-circle"
      title={"Loading..."}
      bgColor="#1E4E69"
    />
    </div>
    )}

       {CancerSitesLoader === true &&  <ShimmerLoader />} 
     {CancerSitesLoader === false && cancerSiteTop10Data && cancerSiteRestOfData && <Fragment>
        <div className="pie_card">
          <div className="row">
            <div className="col-lg-3 cancersite_count-col">
              <div className="card graph_card card_height-1 h_180 mb_space">
                <div className="heading no_cases-bg">
                  <h6 className="mb-0">Number of Patients</h6>

                </div>
                <div className="count_number ">
                  <h1>
                    <CountUp
                      className="countUpValueCard"
                      duration={5}
                      start={0}
                      end={totalValue}
                    />
                  </h1>
                </div>
              </div>
              <div className="card graph_card card_height-1 ">
                <div className="heading primary_cases-bg">
                  <h6 className="mb-0">Primary Cancer Sites</h6>
                </div>
                <div className="count_number">
                  <h1>
                    <CountUp
                      className="countUpValueCard"
                      duration={5}
                      start={0}
                      end={primarySite}
                    />
                  </h1>
                </div>
              </div>
            </div>
            <div className="col-lg-9 mt_md-30">

              {/* new added */}
            <div className='cancersite_main-card card'>
              <div className='cancer_site-heading'>
                   <h6>Cancer Site Distribution</h6>
              </div>
            
            <div className="cancer_site-body">
                 <div className="chart_section">
                     <div className='chart_heading'>
                    <h6>Top 10 Cancer Sites</h6>
                      <span
                        className="pointer"
                        data-toggle="modal"
                        data-target="#topcancerSites" >
                          <img alt="" src={Fullscreen} />
                      </span>
                     
                  </div>
                    <div className='cancer-site_graph_body'>
                    <div className="graph_body-title">
                         {" "}
                        <CountUp
                          className="countUpValue"
                          duration={5}
                          start={0}
                          end={top10totalCount}
                        />
                    </div>
                    <div className='graph_chart-box'>             

                     {cancerSiteTop10Data ? (
                        <HighchartsReact
                          highcharts={Highcharts}
                          options={topcansites}
                        />
                      ) : (
                        <Loader
                          type="spinner-circle"
                          bgColor="black"
                          title={"spinner-circle"}
                          color={"#FFFFFF"}
                          size={100}
                        />
                      )}
                    </div>                  
                    

                   </div>
                    <div className='popup_section'>                        
                      <div className="modal fade " id="topcancerSites">
                        <div className="modal-dialog modal-dialog-centered">
                          <div className="modal-content">
                            <div className="modal-header">
                              <h4 className="modal-title">
                                Top 10 Cancer Sites
                              </h4>
                              <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                              >
                                <i className="zmdi zmdi-close"></i>
                              </button>
                            </div>

                            <div className="modal-body">
                              {cancerSiteTop10Data ? (
                                <HighchartsReact
                                  highcharts={Highcharts}
                                  options={topcansites}
                                />
                              ) : (
                                <Loader
                                  type="spinner-circle"
                                  bgColor="black"
                                  title={"spinner-circle"}
                                  color={"#FFFFFF"}
                                  size={100}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      </div>

              </div>
                <div className="chart_section">
                     <div className='chart_heading'>
                    <h6>Rest of the Cancer Sites</h6>
                        <span
                        className="pointer"
                        data-toggle="modal"
                        data-target="#restcancerSites"
                         onClick={handleModalOpen}
                      >
                        <img alt="" src={Fullscreen} />
                      </span>
                     
                  </div>
                    <div className='cancer-site_graph_body'>
                    <div className="graph_body-title">
                        {" "}
                        <CountUp
                          className="countUpValue"
                          duration={5}
                          start={0}
                          end={totalCount}
                        />
                    </div>
                    <div className='graph_chart-box'>             
                  {cancerSiteRestOfData ? (
                        <HighchartsReact
                          highcharts={Highcharts}
                          options={resofcansites}
                        />
                      ) : (
                        <Loader
                          type="spinner-circle"
                          bgColor="black"
                          title={"spinner-circle"}
                          color={"#FFFFFF"}
                          size={100}
                        />
                      )}
                    </div> 
                   </div>
                    <div className='popup_section'>                        
                      <div className="modal fade " id="restcancerSites">
                        <div className="modal-dialog modal-dialog-centered">
                          <div className="modal-content">
                            <div className="modal-header">
                              <h4 className="modal-title">
                                Rest of the Cancer Sites
                              </h4>
                              <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                 onClick={handleModalClose}
                              >
                                <i className="zmdi zmdi-close"></i>
                              </button>
                            </div>

                            <div className="modal-body">
                              {cancerSiteRestOfData ? (
                                <HighchartsReact
                                  highcharts={Highcharts}
                                  options={resofcansites}
                                />
                              ) : (
                                <Loader
                                  type="spinner-circle"
                                  bgColor="black"
                                  title={"spinner-circle"}
                                  color={"#FFFFFF"}
                                  size={100}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      </div>

              </div>
            </div>
             </div>

            </div>
          </div>
        </div>
      </Fragment>}
    </Fragment>
  );
});

export default CancerSites;
